module.exports = __webpack_public_path__ + "static/media/img2.efb9fa9a.png";